import {backgroundColor, backgroundFields} from './background.fields';
import {align, textColor} from './text.fields';
import {margin, maxWidth, padding, sizeFields} from './box.fields';
import {shadow} from './shadow.fields';


export {background} from './background.fields';
export {box} from './box.fields';
export {image} from './image.fields';
export {shadow} from './shadow.fields';
export {text, align} from './text.fields';


export const simpleBlockFields = [
  {
    ...textColor,
    name: 'text.textColor.xl'
  },
  {
    name: 'box.size',
    label: '',
    component: 'responsive-group',
    fields: sizeFields
  },
  {
    name: 'box',
    label: '',
    component: 'responsive-group',
    fields: [padding, margin]
  },

];


export const pageBlockFields = [
  {
    ...textColor,
    name: 'text.textColor.xl'
  },
  {
    ...backgroundFields[0],
    name: 'background',
  },
  {
    name: 'box',
    label: '',
    component: 'responsive-group',
    fields: [padding]
  }
];

export const pageContentBox = [
  {
    name: 'text',
    label: '',
    component: 'responsive-group',
    fields: [align]
  },
  {
    ...backgroundColor,
    name: 'background.backgroundColor'
  },
  shadow,
  {
    name: 'box.size',
    label: '',
    component: 'responsive-group',
    fields: [maxWidth]
  },
  {
    name: 'box',
    label: '',
    component: 'responsive-group',
    fields: [padding]
  }
];
